export default "__VITE_ASSET__DLj$6CL8__"